import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ba-three-dots-loader',
  templateUrl: './three-dots-loader.component.html',
  styleUrls: ['./three-dots-loader.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThreeDotsLoaderComponent {
  // intentionally empty (presentational component)
}
